/*
 * SonarQube
 * Copyright (C) 2009-2024 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */
.sonarlint-connection-page {
  padding-top: 10vh;
}

.sonarlint-connection-page h1 {
  line-height: 1.5;
  font-size: 24px;
  font-weight: 300;
  text-align: center;
}

.sonarlint-connection-content {
  min-width: 600px;
  width: 40%;
  margin: 0 auto;
}

.sonarlint-connection-page ol {
  list-style: inside decimal;
}

.sonarlint-connection-page .field-label {
  display: inline-block;
  width: 150px;
  color: #656565;
  text-align: start;
  flex-shrink: 0;
}

.sonarlint-connection-page .sonarlint-token-value {
  background-color: #f5f5f5;
  border: 1px solid #e6e6e6;
  padding: 4px 8px;
}
